import { Box, Button, SheetContainer, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";

type AddUserSuccessModalProps = {
  active: boolean;
  email: string;
  onClose: () => void;
};

export const AddUserSuccessModal = ({ active, email, onClose }: AddUserSuccessModalProps) => {
  const i18n = useI18n();

  return (
    <SheetContainer active={active} position="center" size={520} fill hideClose onCloseTrigger={onClose}>
      <Box mixin={{ padding: 8 }}>
        <Stack gap={4} alignItems="start">
          <Stack gap={2}>
            <Text variant="headline_2">{i18n.trans(t("flights_airline_portal_add_user_success_modal_header"))}</Text>
            <Text variant="body_1" color="neutral_alt">
              {i18n.trans(
                t("flights_airline_portal_add_user_success_modal_subheader", {
                  variables: { email_address: email },
                })
              )}
            </Text>
          </Stack>
          <Button size="large" onClick={onClose}>
            {i18n.trans(t("flights_airline_portal_add_user_success_modal_button"))}
          </Button>
        </Stack>
      </Box>
    </SheetContainer>
  );
};
